import {
    GET_ASSET_TYPE,
    GET_NON_REQUISITION_ASSET_TYPE,
    SET_ASSET_TYPE,
    SET_NON_REQUISITION_ASSET_TYPE
} from "./AssetTypeType"

const getAssetType = (isBulkOrder: boolean = false) => ({
    type: GET_ASSET_TYPE,
    isBulkOrder
});

const setAssetType = (assetType: any) => ({
    type: SET_ASSET_TYPE,
    assetType: assetType
});

const getNonRequisitionAssetType = () => ({
    type: GET_NON_REQUISITION_ASSET_TYPE
});

const setNonRequisitionAssetType = (assetType: any) => ({
    type: SET_NON_REQUISITION_ASSET_TYPE,
    assetType: assetType
});

export {
    getAssetType,
    setAssetType,
    getNonRequisitionAssetType,
    setNonRequisitionAssetType
}
